import { IState } from 'core/types';

export const getGameData = ({ game: { gameData } }: IState) => gameData;
